import * as materials from "@lts/materials/legacy/legacy-normal";
export { materials };
export default materials;
